import React, { Component } from 'react';
import './App.css';
import { Route, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import FileUploadForm from './FileUploadForm'
import DropArea from './DropArea'

const firebase = window.firebase;

const Home = props => <h1>Home</h1>


class About extends Component {

  componentWillMount(){
    firebase.auth().onAuthStateChanged(
      function(user) { 
        console.log('current user: ', user); 
      }
    );
  }

  componentDidMount(){
    setTimeout(()=>{
      this.props.history.push('/')
    }, 2000)
  }
  render(){
    return (
      <h1>About</h1>
    )
  }
}


class App extends Component {
  render() {
    return (
      <div className="App">

        <DropArea />

        <Link to="/">HOME</Link> ::
        <Link to="/about">ABOUT</Link> ::

        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />

        <div>
          <h3>Current state:</h3>
          <p>{this.props.message}</p>
        </div>
        <FileUploadForm />

      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { message: state }
}


const ConnectedApp = connect(mapStateToProps)(App);

export default ConnectedApp;



// WEBPACK FOOTER //
// ./src/App.js